// The kiosk page's own strip: schedule, content, screens, devices.
//
// IN THE ADDRESS, NOT ONLY IN REACT STATE. A selected tab that lives only in
// memory is a tab a reload throws away, and the person assembling a rotation
// reloads. Each panel is a path the router already writes, so a pasted link
// opens the same panel.
//
// Tablets stay on /tablets as well as /kiosk/devices, because a bookmark from
// before this strip existed must still work. Both highlight Devices here.
//
// THE DESIGN HANGS THESE FOUR IN THE RAIL, UNDER KIOSK, the way Registration's
// six sit under Registration, and that is where they are now. `className` is how
// one list serves both places: the rail passes "sub" and gets the indented run
// with a rule down its left, and anything drawing it on the page gets the
// design's segmented control. The items and the current-page logic are the same
// either way, which is the point of not writing it twice.

import type { ReactNode } from "react";
import type { KioskPanel } from "../routes/route.js";

export type KioskNavProps = {
  readonly panel: KioskPanel;
  readonly onOpen: (panel: KioskPanel) => void;
  readonly className?: string;
  /**
   * The three pages whose service differs from the playlist's, as
   * roleAccess.ts offers them to this reader. Omitted, all five are drawn.
   */
  readonly offer?: { readonly screens: boolean; readonly devices: boolean; readonly theme: boolean };
};

export const KIOSK_NAV_ITEMS: readonly { readonly panel: KioskPanel; readonly label: string }[] = [
  { panel: "schedule", label: "Schedule" },
  { panel: "content", label: "Content" },
  { panel: "screens", label: "Screens" },
  { panel: "devices", label: "Devices" },
  { panel: "theme", label: "Theme" },
];

export function KioskNav({ panel, onOpen, className, offer }: KioskNavProps): ReactNode {
  const items = KIOSK_NAV_ITEMS.filter(
    (item) =>
      offer === undefined ||
      (item.panel === "screens" ? offer.screens : item.panel === "devices" ? offer.devices : item.panel === "theme" ? offer.theme : true),
  );
  return (
    <nav className={className === undefined ? "seg2 kiosk-panels" : className} aria-label="Kiosk">
      {items.map((item) => (
        <button
          key={item.panel}
          type="button"
          aria-current={item.panel === panel ? "page" : undefined}
          onClick={() => onOpen(item.panel)}
        >
          {item.label}
        </button>
      ))}
    </nav>
  );
}
